import React from 'react';
import { FileText, RefreshCw } from 'lucide-react';
import ContentGenerationService from '../common/ContentGenerationService';

const SynopsisService = ({
  synopsisYoutubeUrl,
  setSynopsisYoutubeUrl,
  youtubeVideoInfo,
  extractingVideoInfo,
  setYoutubeVideoInfo,
  generatedSynopsis,
  currentSynopsisProjectId,
  isProcessing,
  handleSynopsisProcessing,
  handleViewSynopsisProject,
  fetchSynopsisPrompt,
  synopsisPrompt,
  synopsisPromptVersion,
  synopsisPromptTotalVersions,
  selectedPromptVersionForUse,
  isEditingSynopsisPrompt,
  editedSynopsisPrompt,
  synopsisPromptLoading,
  setIsEditingSynopsisPrompt,
  setEditedSynopsisPrompt,
  handleSynopsisPromptVersionChange,
  saveSynopsisPrompt,
  setSelectedPromptVersionForUse,
  fetchSynopsisPromptVersion,
  selectedPromptId,
  user = null,
}) => {
  return (
    <ContentGenerationService
      config={{
        featureType: 'synopsis',
        featureName: 'Synopsis Generation',
        icon: FileText,
        color: 'sky',
        youtubeUrl: synopsisYoutubeUrl,
        setYoutubeUrl: setSynopsisYoutubeUrl,
        youtubeVideoInfo,
        setYoutubeVideoInfo,
        extractingVideoInfo,
        generatedContent: generatedSynopsis,
        currentProjectId: currentSynopsisProjectId,
        isProcessing,
        handleProcessing: handleSynopsisProcessing,
        handleViewProject: handleViewSynopsisProject,
        setShowSettingsModal: () => {},
        user,
        fetchPrompt: fetchSynopsisPrompt,
        prompt: synopsisPrompt,
        promptVersion: synopsisPromptVersion,
        promptTotalVersions: synopsisPromptTotalVersions,
        selectedPromptVersionForUse,
        isEditingPrompt: isEditingSynopsisPrompt,
        editedPrompt: editedSynopsisPrompt,
        promptLoading: synopsisPromptLoading,
        setIsEditingPrompt: setIsEditingSynopsisPrompt,
        setEditedPrompt: setEditedSynopsisPrompt,
        handlePromptVersionChange: handleSynopsisPromptVersionChange,
        savePrompt: saveSynopsisPrompt,
        setSelectedPromptVersionForUse,
        fetchPromptVersion: fetchSynopsisPromptVersion,
        selectedPromptId,
        projectTypes: [
          { value: 'synopsis_generation', label: 'Synopsis Generation', icon: FileText },
          { value: 'synopsis_comparison', label: 'Comparison Analysis', icon: RefreshCw }
        ],
        defaultProjectType: 'synopsis_generation',
        showComparisonOption: true,
      }}
    />
  );
};

export default SynopsisService;
